import { preference } from 'vue-preferences';
export const apiUrl = "https://carte.abidjan.net/pro/";
export const _reference = preference('_reference');